import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/**
 * P5 — what the free-ticket programme actually costs. Spend is `USE − RETURN`:
 * raw USE over-counts because a ticket can be RETURNed and USEd again.
 */
export const ArenaOpsMoneyFreeTicketValueResponseSchema = z.object({
  granted: z.number().int(),
  used: z.number().int(),
  returned: z.number().int(),
  faceIssuedUsdt: ArenaOpsUsdtSchema,
  faceUsedUsdt: ArenaOpsUsdtSchema,
  faceReturnedUsdt: ArenaOpsUsdtSchema,
  /** faceUsed − faceReturned. The figure any cost tile must render. */
  netFaceSpentUsdt: ArenaOpsUsdtSchema,
});
export type ArenaOpsMoneyFreeTicketValueResponse = z.infer<typeof ArenaOpsMoneyFreeTicketValueResponseSchema>;
